import { useParams, Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Clock, User, ArrowLeft } from 'lucide-react'
import { announcements } from '../data'
import { formatDate } from '../utils'
import { Button } from '../components/common'

export function AnnouncementDetailPage() {
  const { id } = useParams<{ id: string }>()
  const announcement = announcements.find(a => a.id === id)

  if (!announcement) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">公告不存在</h1>
          <p className="text-gray-600 mb-6">您访问的公告可能已被删除或不存在</p>
          <Button asChild>
            <Link to="/announcement">返回公告列表</Link>
          </Button>
        </div>
      </div>
    )
  }

  const categoryLabel = {
    notice: '通知',
    news: '新闻',
    update: '更新'
  }

  const categoryStyle = {
    notice: 'bg-blue-100 text-blue-700',
    news: 'bg-green-100 text-green-700',
    update: 'bg-orange-100 text-orange-700'
  }

  return (
    <>
      <section className="relative h-60 bg-gray-900 text-white">
        <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(/images/announcement-banner.jpg)` }}></div>
        <div className="container-custom h-full flex items-center relative z-10">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold mb-4">公告详情</h1>
            <p className="text-lg text-white/80">了解最新系统动态和行业资讯</p>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <Link
                to="/announcement"
                className="inline-flex items-center text-primary-500 hover:text-primary-600 mb-6 transition-colors"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                返回公告列表
              </Link>

              <article className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
                <header className="mb-8 pb-8 border-b border-gray-100">
                  <div className="flex items-center justify-between mb-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${categoryStyle[announcement.category]}`}>
                      {categoryLabel[announcement.category]}
                    </span>
                  </div>
                  <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                    {announcement.title}
                  </h1>
                  <div className="flex items-center space-x-6 text-sm text-gray-500">
                    <div className="flex items-center space-x-2">
                      <Clock className="w-4 h-4" />
                      <span>{formatDate(announcement.date)}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <User className="w-4 h-4" />
                      <span>{announcement.author}</span>
                    </div>
                  </div>
                </header>

                <div className="prose prose-gray max-w-none">
                  {announcement.content.split('\n').map((paragraph, index) => (
                    <p key={index} className="text-gray-700 leading-relaxed mb-4">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </article>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  )
}
